import styled from 'styled-components';

export const Wrapper = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 55px;
  overflow: auto;
  color: ${(props) => props.theme['color.text.body']};
  background: ${(props) => props.theme['color.background']};

  @media(max-width: ${(props) => props.theme['media.mobile']}px) {
    padding: 10px;
  }
`;

export const CardWrapper = styled.div`
  max-width: 500px;
  width: 100%;

  h2 {
    font-weight: 600;
    margin-bottom: 30px;
  }
`;
